const SiteConfig = {
    argh: {
        dark: false,
        sitename: "argh",
        themes: {
            light: {
                background: "#ffffff",
                surface: "#ffffff",
                primary: '#344955',
                primary_modal: '#00ACC1',
                secondary: '#F9AA33',
                tertiary: '#232F34',
                quaternary: '#4A6572',
                image_background: "#CFD8DC",
                card_background: "#ffffff"
            }
        },
        name: "MIT.nano Argh!",
        label: "Submit Feedback about Everyday Lab Issues",
        textlabel: "Problem description",
        submitlabel: "Submit to Argh!"
    },
    nanopi: {
        dark: false,
        sitename: "nanopi",
        themes: {
            xlight: {
                background: "#ffffff",
                surface: "#ffffff",
                primary: '#1A237E',
                primary_modal: '#00ACC1',
                secondary: '#00ACC1',
                accent: '#720D5D',
                error: '#F57C00',
                image_background: "#CFD8DC",
                card_background: "#ffffff"
            },
            /*light: {
                background: "#F9FBE7",
                surface: "#546E7A",
                primary: '#FFB300',
                primary_modal: '#FF8F00',
                secondary: '#880E4F',
                accent: '#FFD180',
                error: '#FFE0B2',
                image_background: "#FFF8E1",
                card_background: "#ffffff"
            }*/
                light: {
                    background: "#FFF3E0",
                    surface: "#546E7A",
                    primary: '#f87217',
                    primary_modal: '#FF8F00',
                    secondary: '#1565C0',
                    accent: '#FFD180',
                    error: '#FFE0B2',
                    image_background: "#EFEBE9",
                    card_background: "#ffffff"
                }
        },
        name: "MIT.nano PI Feedback",
        label: "Submit Feedback and Suggestions for MIT.nano",
        textlabel: "Your Problem, Idea, or Suggestions",
        submitlabel: "Submit to MIT.nano",
        faq: true,
    }
}

module.exports = SiteConfig.nanopi